"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setApiUrl = setApiUrl;
exports.config = void 0;

var _httpClient = require("./httpClient");

var config = {
  apiUrl: 'https://api.mapistry.com'
};
exports.config = config;

function setApiUrl(apiUrl) {
  config.apiUrl = apiUrl;
  _httpClient.http.defaults.baseURL = apiUrl;
}